import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";

import {
  FiHome,
  FiLogOut,
  FiArrowLeftCircle,
  FiArrowRightCircle,
} from "react-icons/fi";

import "react-pro-sidebar/dist/css/styles.css";
import "./sidebar.css";

import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { Icon } from "@fluentui/react/lib/Icon";

import SmallLogo from "../../assets/images/smallNoPadding.svg";
import BigLogo from "../../assets/images/bigNoPadding.svg";

initializeIcons();
const IconOpenMenu = () => <Icon iconName="ChevronRightSmall" />;
const IconCloseMenu = () => <Icon iconName="ChevronLeftSmall" />;
const IconCdr = () => <Icon iconName="BulletedListMirrored" />;
const IconStats = () => <Icon iconName="Financial" />;
const IconRealtime = () => <Icon iconName="People" />;
const IconApi = () => <Icon iconName="AzureAPIManagement" />;
const IconHome = () => <Icon iconName="Home" />;
const IconHashtags = () => <Icon iconName="Label" />;
const IconManageUsers = () => <Icon iconName="FabricUserFolder" />;
const Sidebar = () => {
  const [menuCollapse, setMenuCollapse] = useState(false);
  const [isCdr, setidCdr] = useState(false);
  const [isStats, setIsStats] = useState(false);
  const [isRealtime, setIsRealTime] = useState(false);
  const [isTags, setIsTags] = useState(false);
  const [isApi, setIsApi] = useState(false);
  const [isManageUsers, setIsManageUsers] = useState(false);

  const logout = () => {
    sessionStorage.setItem("tokenStats", "");
    window.location.href = "/";
  };
  const menuIconClick = () => {
    menuCollapse ? setMenuCollapse(false) : setMenuCollapse(true);
  };

  useEffect(() => {
    const cdr = sessionStorage.getItem("cdr");
    setidCdr(cdr);
    const stats = sessionStorage.getItem("stats");
    setIsStats(stats);
    const tags = sessionStorage.getItem("tags");
    setIsTags(tags);
    const api = sessionStorage.getItem("api");
    setIsApi(api);
    const realtime = sessionStorage.getItem("realtime");
    setIsRealTime(realtime);
    const manageUsers = sessionStorage.getItem("manageUsers");
    setIsManageUsers(manageUsers);
  }, []);

  return (
    <>
      <ProSidebar collapsed={menuCollapse}>
        <SidebarHeader>
          <div className="logotext">
            {menuCollapse ? (
              <img
                style={{
                  marginLeft: -11,
                  width: 80,
                  height: 50,
                  marginTop: 15,
                }}
                src={SmallLogo}
                alt="Small Logo"
              ></img>
            ) : (
              <img
                style={{
                  width: 250,
                  height: 60,
                  marginTop: 10,
                  marginLeft: 14,
                }}
                src={BigLogo}
                alt="Big Logo"
              ></img>
            )}
          </div>
          <div className="closemenu" onClick={menuIconClick}>
            {/* changing menu collapse icon on click */}
            {menuCollapse ? <FiArrowRightCircle /> : <FiArrowLeftCircle />}
          </div>
        </SidebarHeader>
        <SidebarContent>
          <Menu iconShape="square">
            <MenuItem icon={<IconHome />} active={true}>
              Home
            </MenuItem>
            {isCdr === "true" && (
              <MenuItem icon={<IconCdr />}>
                <Link to="/cdr"></Link>CDR
              </MenuItem>
            )}
            {isStats === "true" && (
              <MenuItem icon={<IconStats />}>
                <Link to="/stats"></Link>Stats
              </MenuItem>
            )}
            {isRealtime === "true" && (
              <MenuItem icon={<IconRealtime />}>
                <Link to="/realtime"></Link>Realtime
              </MenuItem>
            )}
            {isTags === "true" && (
              <MenuItem icon={<IconHashtags />}>
                <Link to="/tags"></Link>Tags
              </MenuItem>
            )}
            {isApi === "true" && (
              <MenuItem icon={<IconApi />}>
                <Link to="/api"></Link>API
              </MenuItem>
            )}
            {isManageUsers === "true" && (
              <MenuItem icon={<IconManageUsers />}>
                <Link to="/manageUsers"></Link>Manage Users
              </MenuItem>
            )}
          </Menu>
        </SidebarContent>
        <SidebarFooter>
          <Menu iconShape="square">
            <MenuItem onClick={logout}>Logout</MenuItem>
          </Menu>
        </SidebarFooter>
      </ProSidebar>
    </>
  );
};

export default Sidebar;
